import { createAction } from '@shared/modules/event-bus/utils/create-action.util';
import { bulkEditActionTypes } from '@shared/modules/bulk-edit-bar/actions/bulk-edit.action-types';

export default {
  saveBulkEdit: () => createAction(bulkEditActionTypes.saveBulkEdit),
  confirmBulkEdit: () => createAction(bulkEditActionTypes.confirmBulkEdit),
  refreshAfterFinished: () => createAction(bulkEditActionTypes.refreshAfterFinished),
};
